import { Intent } from "@blueprintjs/core";
import classNames from "classnames";
import React, { useState } from "react";

import { Button } from "../../components";
import { CreateSeriesModal } from "../../components/CreateSeriesModal/create-series-modal";
import CreateTeamModal from "../../components/CreateTeamModal/create-team-modal";
import { TagCreator } from "../../components/TagCreator/tag-creator";
import { FieldTypes, FieldTypesSingular } from "../../types";
import { Series } from "./Series/series.tab";
import { Tags } from "./Tags/tags.tab";
import { Teams } from "./Teams/teams.tab";
import styles from "./manage-fields.module.scss";

enum Modals {
  CreateTeam = "CreateTeam",
  CreateSeries = "CreateSeries",
  CreateTag = "CreateTag",
}

export const ManageFields = () => {
  const [activeTab, setActiveTab] = useState<FieldTypes>(FieldTypes.TEAMS);
  const [modal, setModal] = useState<Modals | null>(null);

  const modalDict = {
    [Modals.CreateTeam]: <CreateTeamModal show={true} handleClose={() => setModal(null)} />,
    [Modals.CreateSeries]: <CreateSeriesModal show={true} handleClose={() => setModal(null)} />,
    [Modals.CreateTag]: <TagCreator show={true} handleClose={() => setModal(null)} />,
  };

  let content = <></>;
  if (activeTab === FieldTypes.TEAMS) {
    content = <Teams />;
  } else if (activeTab === FieldTypes.SERIES) {
    content = <Series />;
  } else if (activeTab === FieldTypes.TAGS) {
    content = <Tags />;
  }

  const handleCreateClick = () => {
    if (activeTab === FieldTypes.TEAMS) {
      setModal(Modals.CreateTeam);
    } else if (activeTab === FieldTypes.SERIES) {
      setModal(Modals.CreateSeries);
    } else if (activeTab === FieldTypes.TAGS) {
      setModal(Modals.CreateTag);
    }
  };

  return (
    <div className={styles.manageFields}>
      <div className={styles.fieldNavContainer}>
        <div className={styles.fieldButtonsContainer}>
          <div
            className={classNames(styles.fieldButton, { [styles.active || ""]: activeTab === FieldTypes.TEAMS })}
            onClick={() => setActiveTab(FieldTypes.TEAMS)}
          >
            {FieldTypes.TEAMS}
          </div>
          <div
            className={classNames(styles.fieldButton, { [styles.active || ""]: activeTab === FieldTypes.SERIES })}
            onClick={() => setActiveTab(FieldTypes.SERIES)}
          >
            {FieldTypes.SERIES}
          </div>
          <div
            className={classNames(styles.fieldButton, { [styles.active || ""]: activeTab === FieldTypes.TAGS })}
            onClick={() => setActiveTab(FieldTypes.TAGS)}
          >
            {FieldTypes.TAGS}
          </div>
        </div>
        <Button icon="add" intent={Intent.PRIMARY} onClick={handleCreateClick}>
          CREATE {FieldTypesSingular[activeTab]}
        </Button>
      </div>
      {content}
      {modal && modalDict[modal]}
    </div>
  );
};
